import React from 'react';
import { inject, observer } from 'mobx-react';

const ServerNameHelpTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('SERVER_NAME_TOOLTIP')}
            </div>
}));

const HostNameHelpTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_SERVER_HOSTNAME')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    ldap.company.com
                </code>
            </div>
}));

const PortHelpTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('PORT_OF_THE_LDAP_SERVER')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    389, 636 (for SSL)
                </code>
            </div>
}));

const UserNameTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_BIND_USER_NAME')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    user@domain.name or cn=user,dc=domain,dc=name
                </code>
            </div>
}));

const PasswordTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_PASSWORD_TOOLTIP')}
            </div>
}));

const EnableSSOTooltip = inject('translationsStore')(observer((props) => {

    return <div style={{
        width: 450
    }}>
                {`${props.translationsStore.translate('ENABLE_SSO')} ${props.translationsStore.translate('MAP_LDAP_TO_ACTIVE_DIRECTORY_TITLE')}:`}
                <br />
                {props.translationsStore.translate('ENABLED_ONLY_FOR_ACTIVE_DIRECTORY')}
                <br />
                {props.translationsStore.translate('ENABLE_SSO_TOOLTIP_DESCRIPTION')}            
            </div>
}));

const DirectoryTypeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('DIRECTORY_TYPE_HELP_TOOLTIP')}
            </div>
}));

const BaseDnTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_BASE_DN_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    cn=users,dc=example,dc=com
                </code>
            </div>
}));

const AdditionalUserDnTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_ADDITIONAL_USER_DN_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    ou=People
                </code>
            </div>
}));

const UserObjectSchemaTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_OBJECT_SCHEMA_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    user, inetOrgPerson
                </code>
            </div>
}));

const UserObjectFilterTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_OBJECT_FILTER_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    (objectCategory=Person)
                </code>
            </div>
}));

const UserNameAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_NAME_ATTRIBUTE_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    cn, sAMAccountName
                </code>
            </div>
}));

const UserFirstNameAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_FIRST_NAME_ATTRIBUTE_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    givenName
                </code>
            </div>
}));

const UserLastNameAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_LAST_NAME_ATTRIBUTE_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    sn
                </code>
            </div>
}));

const UserEmailAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_EMAIL_ATTRIBUTE_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    mail
                </code>
            </div>
}));

const AdditionalGroupDnTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('ADDITIONAL_GROUP_DN_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    ou=Groups
                </code>
            </div>
}));

const GroupObjectSchemaTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('GROUP_OBJECT_CLASS_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    groups
                </code>
            </div>
}));

const GroupObjectFilterTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('GROUP_OBJECT_FILTER_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    (objectCategory=Group)
                </code>
            </div>
}));

const GroupNameAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('GROUP_NAME_ATTRIBUTE_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    name
                </code>
            </div>
}));

const GroupMemberAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('GROUP_MEMBERS_ATTRIBUTE_MEMBER_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    member
                </code>
            </div>
}));

const GroupMemberOfAttributeTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('USER_MEMBERSHIP_ATTRIBUTE_MEMBEROF_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    memberOf
                </code>
            </div>
}));

const LdapGroupDnTooltip = inject('translationsStore')(observer((props) => {

    return <div>
                {props.translationsStore.translate('LDAP_GROUP_DN_HELP_TOOLTIP')}
                <br />
                {props.translationsStore.translate('EXAMPLE')}: <code>
                    {'cn=dev,ou=grp,dc=my,dc=org;cn=qa,ou=grp,dc=my,dc=org'}
                </code>
                <br />
                {props.translationsStore.translate('LDAP_GROUP_WILDCARD_HELP_TOOLTIP')}
                <br />
                <code>
                    {'cn=group_north_lead,ou=grp,dc=my,dc=org; cn=group_south_lead,ou=grp,dc=my,dc=org'}
                </code>
                <br />
                {props.translationsStore.translate('EXAMPLE')}:
                <br />
                <code>
                    {'cn=group_*_lead,ou=grp,dc=my,dc=org'}
                </code>
            </div>
}));

export { 
    ServerNameHelpTooltip,
    HostNameHelpTooltip,
    PortHelpTooltip,
    UserNameTooltip,
    PasswordTooltip,
    EnableSSOTooltip,
    DirectoryTypeTooltip,
    BaseDnTooltip,
    AdditionalUserDnTooltip,
    UserObjectSchemaTooltip,
    UserObjectFilterTooltip,
    UserNameAttributeTooltip,
    UserFirstNameAttributeTooltip,
    UserLastNameAttributeTooltip,
    UserEmailAttributeTooltip,
    AdditionalGroupDnTooltip,
    GroupObjectSchemaTooltip,
    GroupObjectFilterTooltip,
    GroupNameAttributeTooltip,
    GroupMemberAttributeTooltip,
    GroupMemberOfAttributeTooltip,
    LdapGroupDnTooltip
}